<template>
  <div class="enterpriseParty">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws12" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="社会统一信用代码" prop="creditCode">
          <el-input v-model="ruleForm.creditCode" placeholder="请输入社会统一信用代码" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="企业名称" prop="enterpriseName">
          <el-input v-model="ruleForm.enterpriseName" placeholder="请输入企业名称" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="企业简称" prop="enterpriseSimpleName">
          <el-input v-model="ruleForm.enterpriseSimpleName" placeholder="请输入企业简称" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item label="是否建立党组织" prop="hasParty">
          <el-select v-model="ruleForm.hasParty" placeholder="请选择">
            <el-option v-for="item in hasParty" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="党组织类型" prop="partyType"
          :rules="ruleForm.hasParty==1 ? rules.partyType : [{ required:false}]">
          <el-select v-model="ruleForm.partyType" placeholder="请选择">
            <el-option v-for="item in partyType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="党组织成立时间" prop="foundDate"
          :rules="ruleForm.hasParty==1 ? rules.foundDate : [{ required:false}]">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.foundDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item tem label="党组织负责人" prop="leader"
          :rules="ruleForm.hasParty==1 ? rules.leader : [{ required:false}]">
          <el-input v-model="ruleForm.leader" placeholder="请输入党组织负责人" class="item-input" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item tem label="党员总数(人)" prop="partyMemberNum">
          <el-input v-model="ruleForm.partyMemberNum" placeholder="请输入党员总数（没有党员则填0）" class="item-input" type="number"
            maxlength="15"></el-input>
        </el-form-item>
        <el-form-item tem label="委员总数(人)" prop="committeeMemberNum"
          :rules="ruleForm.hasParty==1 ? rules.committeeMemberNum : [{ required:false}]">
          <el-input v-model="ruleForm.committeeMemberNum" placeholder="请输入委员总数" class="item-input" type="number"
            maxlength="15"></el-input>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:enterpriseParty
   *@Description:企业党组织建设情况
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        id: '', // id
        isDisabled: true, // 保存的可点击
        saveData: '',
        hasParty: this.$i18n.t('lang.hasParty'),
        partyType: this.$i18n.t('lang.partyType'),
        rules: {
          creditCode: [{
            required: true,
            message: '请输入社会统一信用代码',
            trigger: 'blur'
          }],
          enterpriseName: [{
            required: true,
            message: '请输入企业名称',
            trigger: 'blur'
          }],
          enterpriseSimpleName: [{
            required: true,
            message: '请输入企业简称',
            trigger: 'blur'
          }],

          hasParty: [{
            required: true,
            message: '请选择是否建立党组织',
            trigger: 'change'
          }],
          partyType: [{
            required: true,
            message: '请选择党组织类型',
            trigger: 'change'
          }],
          foundDate: [{
            required: true,
            message: '请选择党组织成立时间',
            trigger: 'change'
          }],
          leader: [{
            required: true,
            message: '请输入党组织负责人',
            trigger: 'blur'
          }],
          partyMemberNum: [{
            required: true,
            type: 'integer',
            message: '请输入党员总数（正整数）',
            trigger: 'blur'
          }],
          committeeMemberNum: [{
            required: true,
            type: 'integer',
            message: '请输入委员总数（正整数）',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          creditCode: '', // 社会统一信用代码
          enterpriseName: '', // 企业名称
          enterpriseSimpleName: '', // 企业简称
          hasParty: '', // 是否建立党组织
          partyType: '', // 党组织类型
          foundDate: '', // 党组织成立时间
          leader: '', // 党组织负责人
          partyMemberNum: '', // 党员总数
          committeeMemberNum: '', // 委员总数
        },
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
      'ruleForm.partyMemberNum': function (a, b) {
        if (!isNaN(parseFloat(a))) {
          this.ruleForm.partyMemberNum = a - 0
        }
      },
      'ruleForm.committeeMemberNum': function (a, b) {
        if (!isNaN(parseFloat(a))) {
          this.ruleForm.committeeMemberNum = a - 0
        }
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取详情数据
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawCompanyCpcOrg?gardenId=${this.gardenId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.list.length > 0) {
                this.ruleForm.creditCode = res.list[0].creditCode
                this.ruleForm.enterpriseName = res.list[0].enterpriseName
                this.ruleForm.enterpriseSimpleName = res.list[0].enterpriseSimpleName
                this.ruleForm.hasParty = res.list[0].hasParty
                this.ruleForm.partyType = res.list[0].partyType
                this.ruleForm.foundDate = res.list[0].foundDate
                this.ruleForm.leader = res.list[0].leader
                this.ruleForm.partyMemberNum = res.list[0].partyMemberNum
                this.ruleForm.committeeMemberNum = res.list[0].committeeMemberNum
                this.id = res.list[0].id
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData = JSON.stringify(this.ruleForm)
                console.log(this.ruleForm)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            this.$post('/gardenDrawCompanyCpcOrg', params).then(
              res => {
                loading.close()
                console.log(res)
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isDisabled = true
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.ruleForm.creditCode = ''
        this.ruleForm.enterpriseName = ''
        this.ruleForm.enterpriseSimpleName = ''
        this.ruleForm.hasParty = ''
        this.ruleForm.partyType = ''
        this.ruleForm.foundDate = ''
        this.ruleForm.leader = ''
        this.ruleForm.partyMemberNum = ''
        this.ruleForm.committeeMemberNum = ''
      }

    },
  }
</script>

<style lang="scss">
  .enterpriseParty {

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>